var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    fill: "currentColor",
    viewBox: "0 0 25 23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.392 22.993 2.377 12.355C.332 10.18-.203 6.852 1.049 4.07 1.918 2.136 3.525.735 5.458.215c1.885-.506 3.881-.109 5.467 1.09a5.498 5.498 0 0 1 1.453 1.647 5.578 5.578 0 0 1 1.454-1.647C15.425.106 17.421-.29 19.3.215c1.933.52 3.54 1.928 4.41 3.856 1.251 2.788.716 6.117-1.33 8.291L12.393 23v-.007ZM7.086 1.688c-.404 0-.814.05-1.218.159-1.46.39-2.684 1.466-3.345 2.94-.967 2.151-.556 4.715 1.022 6.39l8.847 9.404 8.826-9.396c1.58-1.668 1.99-4.24 1.023-6.392-.66-1.473-1.878-2.542-3.346-2.939-1.412-.383-2.907-.08-4.103.823-.995.751-1.586 1.98-1.586 3.294h-1.641c0-1.315-.591-2.55-1.586-3.294a4.802 4.802 0 0 0-2.886-.982l-.007-.007Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Like.336b8ca6be76a2e3c552bde757f69ad9.svg";